// @ts-nocheck
import { createMachine, assign } from 'xstate';
import logger from '../../logger';
// import { track } from '../utils/trackers';
import { isLoggedIn } from '../../utils/DryCookies';
import { signOutAndRedirect, validateFirebaseAuth } from '../../utils/firebaseAuth';
import authLog from '../../utils/authDebugLog';

import requiredAppDataState from './appState_requiredAppDataState';
import primeApplicationState from './appState_primeApplicationState';
import applicationReadyState from './ready/index';
import constants from '../../constants';
import { AppStateContext, AppStateEvent } from '../../types/appState';
import { notebookTreeHelper } from '../../utils/helpers';
import { openNoteHelper } from '../../utils/noteHelpers';
const { SELECTED_NOTEBOOK } = constants;

export const appStateMachine = createMachine(
  {
    schema: {
      context: {} as AppStateContext,
      events: {} as AppStateEvent,
    },
    /** @xstate-layout N4IgpgJg5mDOIC5QEMAOqDKAXZWwDoBLAO0JwBtCAvMAYgG0AGAXUVFQHtYzCPi2QAD0QAmABwBGfAHZGAZgkiALHPkBWFSIA0IAJ6ixANnyGlSyXLXS50w-MMBfBzrSYcefADdklCLjAAMhxQMBAAksTY-gCCAAphtBB8BCSeHADWBN6+MQCuWAAWTKxIIJzcWLz8pcII0iJSpgCcTZJtKhJNOvoIIqYyagpqEoZGtkqOziCuUR7ZhH54QSGQEbNgcQlgAE7bHNv4qOS4AGb7ALZePgt5hcUC5Tx8ArX1jUotbRJiHV16iJZpPhxCommpDBoJN8Rk4XOh1lccktgqE1u4NvFaABVWIAEWiABUAKIAfQA6mEAHK4gDyZJJuKJBOiYQCGHupUelWeNUQE0YwMkIjkhjkIiajGG3UQElsJhEakYijM4Ksalh03h6MRN2RK3CkXRm1oBJpAHEzQFSbFopSiQESQA1MIYaIAIVZYQJAE0OewuE9qqBako1E18GZRtIlMKJhNDIZpQhJPhGE0bIM1CJ6hpRhqZtr5oswAAlMAAR1yhG2kGi6FxuGQDBYDwD3KDQgMUlkCmUqksmiTch+wMYY7kcia4ukYKcU2IHAgcAEBf8rYqVReiAAtIn-ghd-mtf4iKQKNQwOvA1uELKpIMVDOIWLGBClEnxGoI8O1OCxIwFVGeQjzcE8i38ZZUUNGJ4ivdsbwmcMFQUCRLChDQxGkNQP2kIEJHBbNUNMV95DkECEROMAsAAYwKMtK2rWt60bODN15BAJSBIxlHTKFX3-MQPyMYFpG+CVULDJU5CUcjC2uYt6KrGsIDrVAGxwVieWDPltH3YcRGBR9pDEcQXxFWST1QbZCHODZ0EoajcDY-0Ny0zsEEQ4FBihND8PMLChxMwybGM0yRHsCyPFcBynL4MtkAgHoXOvdj6lTCFDD6NNzAkUNsP3EQ+nwJozGMpprGkzCxDESKCHIFFIBpfJNI7WpOPwbiPhQ-jGEEvTf3wRVMvCpQRjBcyplXDwiRLEsaRLFqbyC-TJFkcaRTDJMzAFawsNDSxCrEEUyLnIA */
    predictableActionArguments: true,

    // https://xstate.js.org/docs/guides/context.html#action-order
    preserveActionOrder: true,
    // internal: true,
    id: 'appState',

    // Initial state
    // description: "This is the top level state machine for the application. It is responsible for initializing the application and fetching the required data for the application to function.",
    initial: 'initalize',

    /* Local context for entire machine */
    context: {
      applicationPrimed: false,
      applicationTitle: 'DryNotes',
      dryChromeMachineRef: null,
      modalMachineRef: null,
      loggedIn: false,
      authRetryCount: 0,
      errorPageMessage: 'Something went wrong',
      hasError: false,
      baseFontColor: '#333333', // Does NOT change
      selectedFontColor: '#333333',
      editorType: 'wysiwyg', // 'wysiwyg' or 'html',
      attachmentsVisibility: false,
      attachmentStatus: 'idle',
      attachmentNoteId: null,
      pendingUploadFiles: [],
      redirectToLogin: false,

      /* User Settings */
      userSettings: null,
      hasUserSettings: false,
      hasUserSettingsLocalDatabaseContent: false,

      /**
       * Describes the status of the note between in the notes section or trash
       * @notes - The note is in the notes section
       * @trash - The note is in the trash section
       */
      itemStatus: 'notes',

      //* Areas of Focus Collections */
      areasOfFocusCollections: null,
      areasOfFocusCollectionsIterable: [], // Change to a Map
      hasAreasOfFocusCollections: false,
      hasAreasOfFocusCollectionsLocalDatabaseContent: false,
      selectedAreaOfFocus: null,
      selectedAreaOfFocusId: null,
      areaOfFocusOpenNoteObjects: null,
      areaOfFocusOpenNoteIds: null,
      // areaOfFocusOpenNoteObjectsIterable: [],

      /* Notes */
      notes: null,
      notesList: null,
      hasNotes: false,
      hasNotesLocalDatabaseContent: false,
      selectedNote: null,
      selectedNoteId: null,
      noteSyncStatuses: {},

      /* Labels */
      labels: {},
      hasLabels: false,

      /* Trash */
      trashedNotes: {},
      openTrashNotes: [],
      selectedTrashNote: null,
      hasTrashedNotes: false,

      /* New Note Entity Object */
      newNoteEntityObject: {
        note_title: 'untitled',
        // notebook_id: null,
        version: 'v2.0.0',
      },

      /* Notebooks */
      notebooks: null,
      notebooksIterable: [], // Change to a Map
      defaultNotebook: null,
      hasNotebooks: false,
      hasNotebooksLocalDatabaseContent: false,
      selectedNotebook: null,
      selectedNotebookId: null,

      /*
       * Notebook Tree
       * Tree dictionary with note objects, [notebookId][noteId]
       */
      notebookTree: null,

      /*
       * Notebook Tree List
       * Tree dictionary with notes array
       */
      notebookTreeList: null,

      /*
       * All notes in the current selected notebook
       */
      activeNotebookNotes: null,

      /*
       * Notebook Object for the selected Note
       */
      selectedNotesNotebook: null,

      /* User Panel Configs */
      userPanelConfigs: null,
      hasUserPanelConfigs: false,
      hasUserPanelConfigsLocalDatabaseContent: false,

      /* Chrome Models */
      chromeModels: null, // All models
      activeChromeModel: null, // current selected model
      hasChromeModels: false,
      hasChromeModelsLocalDatabaseContent: false,
      activeFlexLayoutModel: null,

      /* UI */
      showPanels: false,
      panelsVisibility: false,
      showSidebar: false,
      showOpenNotesPanel: false,
      showCommandPalette: false,
      showHistoryPanel: false,
      paletteType: 'command', // 'command' or 'note'
      showNoteSearch: false,

      /* Search */
      searchVisibility: false,
      searchResults: [],
      selectedSearchIndex: 0,

      /* Notebook Modal */
      openNotebookModal: false,

      /* Display */
      breakpoint: 'mobile',
      width: null,
      height: null,

      /* Deeplink Error */
      deeplinkError: null,
    },

    // State definitions
    states: {
      initalize: {
        always: {
          target: 'validateLoggedInStateAPI',
        },
      },
      validateLoggedInStateAPI: {
        id: 'validateLoggedInStateAPI',
        invoke: {
          id: 'validateAuth',
          src: async (context, event) => {
            /*
             * Use isLoggedIn() for the initial startup check — it validates
             * the Firebase session directly and is deterministic. waitForAuthState()
             * was tried here but onAuthStateChanged can resolve before Firebase
             * has fully restored the session from IndexedDB persistence.
             */
            authLog('appState:validateLoggedInStateAPI:start');
            try {
              const loggedIn = await isLoggedIn();
              logger.info('Authentication validation result:', loggedIn);
              authLog('appState:validateLoggedInStateAPI:result', { loggedIn });
              return loggedIn;
            } catch (error) {
              logger.error('Authentication validation error:', error);
              authLog('appState:validateLoggedInStateAPI:error', { error: String(error) });
              return false;
            }
          },
          onDone: {
            target: 'fetchRequiredAppData',
            actions: assign((context, event) => {
              logger.info('User is now logged in', context, event);
              return {
                loggedIn: event.data,
                authRetryCount: 0,
              };
            }),
          },
          onError: {
            target: 'reauthenticating',
            actions: assign((context, event) => {
              logger.info('Initial auth check failed, entering reauthenticating', event);
              return {
                loggedIn: false,
              };
            }),
          },
        },
      },
      /*
       * This is a child State Node and not a machine
       * Moved to a separate file for readability
       */
      fetchRequiredAppData: { ...requiredAppDataState } as const,

      /*
       * Validate the required data for the app is present, either from local storage or from the cloud
       */
      validateRequiredAppData: {
        always: [
          {
            target: 'primeApplication',
            cond: 'hasRequiredData',
          },
        ],
      },
      /*
       * This is a child State Node and not a machine
       * Moved to a separate file for readability
       */
      primeApplication: {
        ...primeApplicationState,
        always: [
          {
            target: 'applicationReady',
            cond: 'hasPrimedData',
          },
        ],
      } as const,
      /*
       * This is a child State Node and not a machine
       * Moved to a separate file for readability
       */
      applicationReady: {
        ...applicationReadyState,
        entry: [
          assign((context, event) => {
            logger.info('Application is now ready - setting applicationPrimed to true');
            return {
              applicationPrimed: true,
            };
          }),
        ],
      } as const,
      reauthenticating: {
        entry: assign((context, event) => {
          const nextRetry = (context.authRetryCount || 0) + 1;
          logger.info(`reauthenticating: attempt ${nextRetry}/3`);
          authLog('appState:reauthenticating', { attempt: nextRetry, event: (event as any)?.type });
          return { authRetryCount: nextRetry };
        }),
        invoke: {
          id: 'revalidateAuth',
          src: async (context) => {
            // Brief delay before retrying so we don't hammer Firebase
            const delay = Math.min((context.authRetryCount || 1) * 2000, 6000);
            await new Promise((r) => setTimeout(r, delay));
            return validateFirebaseAuth();
          },
          onDone: [
            {
              cond: (context, event) => event.data === true,
              target: 'fetchRequiredAppData',
              actions: assign(() => ({ loggedIn: true, authRetryCount: 0 })),
            },
            {
              cond: (context) => (context.authRetryCount || 0) < 3,
              target: 'reauthenticating',
            },
            {
              target: 'loggedOut',
            },
          ],
          onError: [
            {
              cond: (context) => (context.authRetryCount || 0) < 3,
              target: 'reauthenticating',
            },
            {
              target: 'loggedOut',
            },
          ],
        },
      },
      loggedOut: {
        entry: [
          assign((context, event) => {
            (logger as any).info({ context, event }, 'loggedOut data');
            authLog('appState:loggedOut', { event: (event as any)?.type, authRetryCount: (context as any)?.authRetryCount });
            return {
              loggedIn: false,
            };
          }),
          // Redirect only after reauthenticating exhausted all retries
          () => {
            logger.info('User not authenticated after retries, redirecting to login');
            signOutAndRedirect();
          }
        ],
      },
      ERROR: {
        entry: assign((context, event) => {
          logger.info('ERROR data', context, event);
          return {
            hasError: true,
          };
        }),
      },
    },
    on: {
      /**
       * Update activeFlexLayoutModel globally whenever dryChromeState sends a new model.
       * waitingForModel only handles this during initial load; this root handler keeps
       * the model in sync on breakpoint changes (resize) after the app is fully loaded.
       */
      SetChromeModelFromChild: {
        actions: assign((context: any, event: any) => ({
          activeFlexLayoutModel: event.activeFlexLayoutModel,
        })),
      },
      transitionToRunning: {
        // target: 'applicationReady',
        actions: (context, event) => {
          logger.info('applicationReady transition');
          return;
        }
      },
      /**
       * Forward SelectTab to the DryChrome child machine.
       * urlSyncService sends this event to restore URL-selected panels.
       */
      SelectTab: {
        actions: (context, event) => {
          if (!context.dryChromeMachineRef) return;
          context.dryChromeMachineRef.send(event);
        },
      },
      updateWindowDetails: {
        actions: [
          assign((context, event) => {
            (logger as any).info({ event }, 'updateWindowDetails');
            const {
              value: { breakpoint, width, height },
            } = event;
            return {
              breakpoint,
              width,
              height,
            };
          }),
          // Re-select the chrome model whenever the breakpoint changes.
          // dryChromeMachineRef is null until primeApplicationState spawns it,
          // so the guard prevents premature sends.
          (context, event) => {
            if (!context.dryChromeMachineRef) return;
            context.dryChromeMachineRef.send({
              type: 'SetChromeModel',
              chromeModels: context.chromeModels,
              breakpoint: event.value.breakpoint,
            });
          },
        ],
      },
      togglePanelVisability: {
        actions: assign((context, event) => {
          logger.info({ event }, 'togglePanelVisability');
          return {
            showPanels: !context.showPanels,
          };
        }),
      },
      SHOW_HISTORY_PANEL: {
        actions: assign((_context, event) => {
          logger.info({ event }, 'SHOW_HISTORY_PANEL');
          return { showHistoryPanel: true };
        }),
      },
      HIDE_HISTORY_PANEL: {
        actions: assign((_context, event) => {
          logger.info({ event }, 'HIDE_HISTORY_PANEL');
          return { showHistoryPanel: false };
        }),
      },
      /**
       * Toggle sidebar visibility
       */
      toggleSidebarVisibility: {
        actions: assign((context, event) => {
          logger.info({ event }, 'toggleSidebarVisibility');
          return {
            showSidebar: !context.showSidebar,
          };
        }),
      },
      /**
       * Set sidebar visibility to a specific value
       */
      setSidebarVisibility: {
        actions: assign((context, event) => {
          logger.info({ event }, 'setSidebarVisibility');
          const { value } = event.data || {};
          return {
            showSidebar: value !== undefined ? value : !context.showSidebar,
          };
        }),
      },
      /**
       * Toggle open notes panel visibility
       */
      toggleOpenNotesPanelView: {
        actions: assign((context, event) => {
          logger.info({ event }, 'toggleOpenNotesPanelView');
          return {
            showOpenNotesPanel: !context.showOpenNotesPanel,
          };
        }),
      },
      /**
       * Set open notes panel visibility to a specific value
       */
      setOpenNotesPanelView: {
        actions: assign((context, event) => {
          logger.info({ event }, 'setOpenNotesPanelView');
          const { value } = event.data || {};
          return {
            showOpenNotesPanel: value !== undefined ? value : !context.showOpenNotesPanel,
          };
        }),
      },
      /**
       * Toggle search visibility
       */
      toggleSearchVisibility: {
        actions: assign((context, event) => {
          logger.info({ event }, 'toggleSearchVisibility');
          return {
            searchVisibility: !context.searchVisibility,
          };
        }),
      },
      toggleCommandPalette: {
        actions: assign((context, event) => {
          logger.info({ event }, 'toggleCommandPalette');
          return {
            showCommandPalette: !context.showCommandPalette,
          };
        }),
      },
      /**
       * Set deeplink error
       */
      setDeeplinkError: {
        actions: assign((context, event) => {
          logger.info({ event }, 'setDeeplinkError');
          const { url, reason, invalidId } = event.data || {};
          return {
            deeplinkError: {
              url: url || '',
              reason: reason || 'unknown',
              invalidId: invalidId || null,
            },
          };
        }),
      },
      /**
       * Clear deeplink error
       */
      clearDeeplinkError: {
        actions: assign((context, event) => {
          logger.info({ event }, 'clearDeeplinkError');
          return {
            deeplinkError: null,
          };
        }),
      },
      /**
       * Close search and reset state
       */
      closeSearch: {
        actions: assign((context, event) => {
          logger.info({ event }, 'closeSearch');
          return {
            searchVisibility: false,
            searchResults: [],
            selectedSearchIndex: 0,
          };
        }),
      },
      /**
       * Set search results
       */
      setSearchResults: {
        actions: assign((context, event) => {
          logger.info({ event }, 'setSearchResults');
          const { results } = event.data || {};
          return {
            searchResults: results !== undefined ? results : [],
          };
        }),
      },
      /**
       * Clear search results
       */
      clearSearchResults: {
        actions: assign((context, event) => {
          logger.info({ event }, 'clearSearchResults');
          return {
            searchResults: [],
            selectedSearchIndex: 0,
          };
        }),
      },
      /**
       * Toggle notebook modal visibility
       */
      toggleNotebookModal: {
        actions: assign((context, event) => {
          logger.info({ event }, 'toggleNotebookModal');
          return {
            openNotebookModal: !context.openNotebookModal,
          };
        }),
      },
      /**
       * Set selected search index
       */
      setSelectedSearchIndex: {
        actions: assign((context, event) => {
          logger.info({ event }, 'setSelectedSearchIndex');
          const { index } = event.data || {};
          return {
            selectedSearchIndex: index !== undefined ? index : 0,
          };
        }),
      },
      /**
       * Select next search result
       */
      selectNextSearchResult: {
        actions: assign((context, event) => {
          logger.info({ event }, 'selectNextSearchResult');
          const maxIndex = context.searchResults.length > 0
            ? context.searchResults.length - 1
            : 0;
          const nextIndex = Math.min(context.selectedSearchIndex + 1, maxIndex);
          return {
            selectedSearchIndex: nextIndex,
          };
        }),
      },
      /**
       * Select previous search result
       */
      selectPreviousSearchResult: {
        actions: assign((context, event) => {
          logger.info({ event }, 'selectPreviousSearchResult');
          const prevIndex = Math.max(context.selectedSearchIndex - 1, 0);
          return {
            selectedSearchIndex: prevIndex,
          };
        }),
      },
    },
  },
  {
    actions: {
      /*
       * selectAreaOfFocusCollection
       */
      setSelectAreaOfFocus: assign((context) => {
        const { areasOfFocusCollections, userSettings } = context;
        /*
         * Pull out the selected area of focus ID from user Settings
         */
        const selectedAreaOfFocusId = userSettings?.selected_area_of_focus;

        logger.info(
          {
            selectedAreaOfFocusId,
            hasAreasOfFocusCollections: context.hasAreasOfFocusCollections,
            areasOfFocusCollectionsCount: areasOfFocusCollections
              ? Object.keys(areasOfFocusCollections).length
              : 0,
          },
          'setSelectAreaOfFocus'
        );

        /*
         * Get the entire object for the selected area of focus
         * Expects that areasOfFocusCollections is a key:value pair dictionary
         */
        let selectedAreaOfFocus: Record<string, any> = {};
        let resolvedAreaOfFocusId = selectedAreaOfFocusId;

        if (areasOfFocusCollections && selectedAreaOfFocusId && areasOfFocusCollections[selectedAreaOfFocusId]) {
          selectedAreaOfFocus = areasOfFocusCollections[selectedAreaOfFocusId];
        } else if (areasOfFocusCollections) {
          const aofValues = Object.values(areasOfFocusCollections) as Array<Record<string, any>>;
          if (aofValues.length > 0) {
            if (selectedAreaOfFocusId) {
              // Saved ID doesn't exist in collection — fall back to first available AOF
              logger.warn(
                {
                  selectedAreaOfFocusId,
                  availableIds: Object.keys(areasOfFocusCollections),
                },
                'setSelectAreaOfFocus: saved AOF ID not found, falling back to first available AOF'
              );
              selectedAreaOfFocus = aofValues[0];
              resolvedAreaOfFocusId = aofValues[0].area_of_focus_collection_id;
            }
          }
        }

        return {
          selectedAreaOfFocus,
          selectedAreaOfFocusId: resolvedAreaOfFocusId,
        };
      }),

      /*
       * Set the selected note from selected area of focus.
       *
       * Selection priority (Option B — see context/aof-data-model.md):
       *   1. Last entry in selected_stack — most recently explicitly-selected note.
       *   2. Fallback: order_of_items[length - 1] — most recently opened note.
       *
       * selected_stack may be empty or lag behind order_of_items; that is normal.
       */
      setSelectedNote: assign((context) => {
        /*
         * Get the selected area of focus to find out the selected note
         */
        const selectedAreaOfFocus = context.selectedAreaOfFocus;

        /*
         * First, try to get the note from selected_stack.
         * The API appends the most recently selected note to the END of the array,
         * so we read the last element, not [0].
         */
        const stack = selectedAreaOfFocus?.selected_stack ?? [];
        let selectedNoteId = stack.length > 0 ? stack[stack.length - 1] : null;
        let selectedNote = null;

        // If we have a selectedNoteId from selected_stack, try to get the note
        if (selectedNoteId && context.notes && context.notes[selectedNoteId]) {
          selectedNote = context.notes[selectedNoteId];
        } else {
          // Fallback: If no note in selected_stack or note doesn't exist, use the LAST note from order_of_items
          const orderOfItems = selectedAreaOfFocus?.order_of_items ?? [];
          if (orderOfItems.length > 0) {
            // Get the last note in the array
            const lastNoteId = orderOfItems[orderOfItems.length - 1];
            if (lastNoteId && context.notes && context.notes[lastNoteId]) {
              selectedNoteId = lastNoteId;
              selectedNote = context.notes[lastNoteId];
              logger.info(
                {
                  fallbackToLastNote: true,
                  lastNoteId,
                  orderOfItemsLength: orderOfItems.length,
                },
                'setSelectedNote: Falling back to last note in order_of_items'
              );
            }
          }
        }

        logger.info(
          {
            selectedNoteId,
            hasNotes: context.hasNotes,
            notesCount: context.notes ? Object.keys(context.notes).length : 0,
            noteExists: selectedNoteId && context.notes ? !!context.notes[selectedNoteId] : false,
            hasSelectedNote: !!selectedNote,
            selectedStackLength: selectedAreaOfFocus?.selected_stack?.length ?? 0,
            orderOfItemsLength: selectedAreaOfFocus?.order_of_items?.length ?? 0,
          },
          'setSelectedNote'
        );

        if (selectedNoteId && !selectedNote) {
          logger.warn(
            {
              selectedNoteId,
              hasNotes: context.hasNotes,
              notesKeys: context.notes ? Object.keys(context.notes) : [],
            },
            'setSelectedNote: Note ID found but note object not available yet'
          );
        }

        return {
          selectedNoteId,
          selectedNote,
        };
      }),
      setSelectedNotebook: assign((context) => {
        /*
         * Get the selected notebook from userSettings
         */
        const { userSettings, notebooks } = context;
        const selectedNotebookId = userSettings?.selected_notebook;
        let selectedNotebook;

        logger.info(
          {
            selectedNotebookId,
            hasNotebooks: context.hasNotebooks,
            notebooksCount: notebooks ? Object.keys(notebooks).length : 0,
          },
          'setSelectedNotebook'
        );

        /*
         * Pull out the selected notebookId from userSettings
         * Store a reference to the entire selectedNotebook object into context
         * Fallback to supporting all notes if the notebookId is 'all_notes`
         */
        if (selectedNotebookId === 'all_notes') {
          selectedNotebook = SELECTED_NOTEBOOK;
        } else {
          selectedNotebook = notebooks && notebooks[selectedNotebookId]
            ? notebooks[selectedNotebookId]
            : null;
        }

        if (selectedNotebookId && selectedNotebookId !== 'all_notes' && !selectedNotebook) {
          logger.warn(
            {
              selectedNotebookId,
              availableIds: notebooks ? Object.keys(notebooks) : [],
            },
            'setSelectedNotebook: Notebook ID found but object not available'
          );
        }

        return {
          selectedNotebook,
          selectedNotebookId,
        };
      }),

      createNotebookTree: assign((context) => {
        const { notebooks, selectedNotebook, notes } = context;
        const { notebookTree, notebookTreeList } = notebookTreeHelper({
          notebooks,
          notebookId: selectedNotebook?.notebook_id,
          notes,
        });

        return {
          notebookTree,
          notebookTreeList,
        };
      }),

      setAreasOfFocusOpenNoteObjects: assign((context) => {
        const { selectedAreaOfFocus, notes } = context;
        let areaOfFocusOpenNoteObjects = {};
        let areaOfFocusOpenNoteIds = [];
        let orderOfItems = [];

        /*
         * Create a list of openNotes list of notes on the currently selected area of focus
         */
        if (
          Object.entries(selectedAreaOfFocus).length &&
          Object.entries(notes).length
        ) {
          orderOfItems = selectedAreaOfFocus.order_of_items;
          for (let index = 0; index < orderOfItems.length; index++) {
            const entityId = orderOfItems[index];
            areaOfFocusOpenNoteIds.push(entityId);
            areaOfFocusOpenNoteObjects[entityId] = notes[entityId];
          }
        }

        logger.debug(
          areaOfFocusOpenNoteObjects,
          'getAreasOfFocusOpenNoteObjects modified data'
        );

        return {
          areaOfFocusOpenNoteObjects,
          areaOfFocusOpenNoteIds,
        };
      }),
      createNotesList: assign((context) => {
        const { notes } = context;
        /**
         * Get the dictionary of notes and convert it into an array
         */
        // create a list from keys and values of an object
        const notesList = Object.values(notes);

        return {
          notesList,
        };
      }),
      retrySetSelectedNoteIfNeeded: assign((context) => {
        /**
         * Retry setting the selected note if we have a selectedNoteId from area of focus
         * but the selectedNote is not set (e.g., notes were loaded after initial attempt)
         * Falls back to last note in order_of_items if selected_stack is empty or invalid
         */
        const selectedAreaOfFocus = context.selectedAreaOfFocus;
        const retryStack = selectedAreaOfFocus?.selected_stack ?? [];
        let selectedNoteId = retryStack.length > 0 ? retryStack[retryStack.length - 1] : null;
        let selectedNote = null;

        // If we have a selectedNoteId from stack, try to get the note
        if (selectedNoteId && context.notes && context.notes[selectedNoteId]) {
          selectedNote = context.notes[selectedNoteId];
        } else {
          // Fallback: If no note in selected_stack or note doesn't exist, use the LAST note from order_of_items
          const orderOfItems = selectedAreaOfFocus?.order_of_items ?? [];
          if (orderOfItems.length > 0) {
            const lastNoteId = orderOfItems[orderOfItems.length - 1];
            if (lastNoteId && context.notes && context.notes[lastNoteId]) {
              selectedNoteId = lastNoteId;
              selectedNote = context.notes[lastNoteId];
            }
          }
        }

        logger.info(
          {
            selectedNoteId,
            hasSelectedNote: !!context.selectedNote,
            hasNotes: context.hasNotes,
            notesCount: context.notes ? Object.keys(context.notes).length : 0,
            noteExists: selectedNoteId && context.notes ? !!context.notes[selectedNoteId] : false,
            orderOfItemsLength: selectedAreaOfFocus?.order_of_items?.length ?? 0,
          },
          'retrySetSelectedNoteIfNeeded'
        );

        // If we have a selectedNoteId but no selectedNote, and notes are now loaded, retry
        if (
          selectedNoteId &&
          (!context.selectedNote || !context.selectedNote.note_id) &&
          selectedNote
        ) {
          logger.info(
            { selectedNoteId, selectedNote: selectedNote.note_id },
            'retrySetSelectedNoteIfNeeded: Setting selected note'
          );
          return {
            selectedNoteId,
            selectedNote,
          };
        }

        // No change needed
        return {};
      }),
      openNote: assign((context, event) => {
        const {
          data: {
            noteId
          }
        } = event;
        // Find the note object from the noteId
        const note = context.notes[noteId];
        const updatedContext = openNoteHelper({ context, note });

        return updatedContext;
      }),
      addNoteToAreaOfFocus: assign((context, event) => {
        const { areasOfFocusCollections } = context;
        const {
          data: {
            selectedAreaOfFocusId,
            noteId,
          }
        } = event;

        const { selectedAreaOfFocus, notes, notesList } = context;

        const { order_of_items: openNotesInAreaOfFocus } =
          selectedAreaOfFocus;

        // const {
        //   data: { noteId, selectedAreaOfFocusId },
        // } = event;
        let updatedOpenNotesInAreaOfFocus = openNotesInAreaOfFocus;
        let updatedSelectedAreaOfFocus = selectedAreaOfFocus;

        /**
         * 1. Insert the new noteId into the openNotes array in the editor
         * Add the note to the openNotes array in the selected area of focus
         * Ensure the noteId is not already in the openNotes array
         * @todo move this to a helper method
         */
        //
        if (!openNotesInAreaOfFocus.includes(noteId)) {
          /**
           * Add the noteId to the openNotes array
           */
          updatedOpenNotesInAreaOfFocus = [
            noteId,
            ...openNotesInAreaOfFocus,
          ];

          /**
           * Update the selected area of focus with the new openNotes array
           * @todo move this to a helper method
           * @todo make sure to update the selected_stack too
           */
          updatedSelectedAreaOfFocus = {
            ...context.selectedAreaOfFocus,
            order_of_items: updatedOpenNotesInAreaOfFocus,
          };
        }

        // const selectedAreaOfFocus = areasOfFocusCollections[areaOfFocusId];

        return {
          selectedAreaOfFocus: updatedSelectedAreaOfFocus,
          selectedAreaOfFocusId: selectedAreaOfFocusId,
        };
      }),
      setSelectedNotesNotebook: assign((context) => {
        const { selectedNote, notebooks } = context;
        const selectedNoteObject = selectedNote;

        /*
         * Get the notebook object for the currently selected note
         */
        const selectedNotesNotebook = notebooks[selectedNoteObject?.notebook_id]
          ? notebooks[selectedNoteObject?.notebook_id]
          : null;

        return {
          selectedNotesNotebook,
        };
      }),
    },
    guards: {
      isLoggedIn: (context, event) => {
        logger.debug({ context, event }, 'isLoggedIn context and event');
        logger.info({ loggedIn: context.loggedIn }, 'isLoggedIn context');
        // check if user is logged in
        return !!context.loggedIn;
      },
      isLoggedOut: (context, event) => {
        logger.info({ event }, 'isLoggedOut event');
        // check if user is logged out
        return !context.loggedIn;
      },
      hasNoUserSettingsLocalDatabaseContent: (context, event) => {
        logger.info({ event }, 'hasNoUserSettingsLocalDatabaseContent event');
        // check if user does NOT have local database content
        return !context.hasUserSettingsLocalDatabaseContent;
      },
      hasUserSettingsLocalDatabaseContent: (context, event) => {
        logger.info({ event }, 'hasUserSettingsLocalDatabaseContent event');
        // check if user does NOT have local database content
        return context.hasUserSettingsLocalDatabaseContent;
      },
      hasNoAreasOfFocusCollectionsLocalDatabaseContent: (context, event) => {
        logger.info(
          { event },
          'hasNoAreasOfFocusCollectionsLocalDatabaseContent event'
        );
        // check if user does NOT have local database content
        return !context.hasAreasOfFocusCollectionsLocalDatabaseContent;
      },
      hasAreasOfFocusCollectionsLocalDatabaseContent: (context, event) => {
        logger.info(
          { event },
          'hasAreasOfFocusCollectionsLocalDatabaseContent event'
        );
        // check if user does NOT have local database content
        return context.hasAreasOfFocusCollectionsLocalDatabaseContent;
      },
      hasNoNotesLocalDatabaseContent: (context, event) => {
        logger.info({ event }, 'hasNoNotesLocalDatabaseContent event');
        // check if user does NOT have local database content
        return !context.hasNotesLocalDatabaseContent;
      },
      hasNotesLocalDatabaseContent: (context, event) => {
        logger.info({ event }, 'hasNotesLocalDatabaseContent event');
        // check if user does NOT have local database content
        return context.hasNotesLocalDatabaseContent;
      },
      hasNoNotebooksLocalDatabaseContent: (context, event) => {
        logger.info({ event }, 'hasNoNotebooksLocalDatabaseContent event');
        // check if user does NOT have local database content
        return !context.hasNotebooksLocalDatabaseContent;
      },
      hasNotebooksLocalDatabaseContent: (context, event) => {
        logger.info({ event }, 'hasNotebooksLocalDatabaseContent event');
        // check if user does NOT have local database content
        return context.hasNotebooksLocalDatabaseContent;
      },
      hasNoUserPanelConfigsLocalDatabaseContent: (context, event) => {
        logger.info('hasNoUserPanelConfigsLocalDatabaseContent event', event);
        // check if user does NOT have local database content
        return !context.hasUserPanelConfigsLocalDatabaseContent;
      },
      hasUserPanelConfigsLocalDatabaseContent: (context, event) => {
        logger.info('hasUserPanelConfigsLocalDatabaseContent event', event);
        // check if user does NOT have local database content
        return context.hasUserPanelConfigsLocalDatabaseContent;
      },
      hasNoChromeModelsLocalDatabaseContent: (context, event) => {
        logger.info('hasNoChromeModelsLocalDatabaseContent event', event);
        // check if user does NOT have local database content
        return !context.hasChromeModelsLocalDatabaseContent;
      },
      hasChromeModelsLocalDatabaseContent: (context, event) => {
        logger.info('hasUserChromeModelsLocalDatabaseContent event', event);
        // check if user does NOT have local database content
        return context.hasUserChromeModelsLocalDatabaseContent;
      },
      hasRequiredData: (context, event) => {
        const requiredData =
          context.hasUserSettings &&
          context.hasAreasOfFocusCollections &&
          context.hasNotes &&
          context.hasNotebooks &&
          context.hasUserPanelConfigs &&
          context.hasChromeModels;

        logger.info('hasRequiredData check:', {
          hasUserSettings: context.hasUserSettings,
          hasAreasOfFocusCollections: context.hasAreasOfFocusCollections,
          hasNotes: context.hasNotes,
          hasNotebooks: context.hasNotebooks,
          hasUserPanelConfigs: context.hasUserPanelConfigs,
          hasChromeModels: context.hasChromeModels,
          result: requiredData
        });

        return requiredData;
      },
      hasPrimedData: (context) => {
        // If no AOF collections exist at all, this condition is satisfied (nothing to select).
        const noAofCollections =
          context.hasAreasOfFocusCollections &&
          context.areasOfFocusCollectionsIterable &&
          context.areasOfFocusCollectionsIterable.length === 0;
        const hasSelectedAreaOfFocus =
          noAofCollections ||
          (context.selectedAreaOfFocus &&
          Object.keys(context.selectedAreaOfFocus).length > 0);
        const hasSelectedNotebook =
          context.selectedNotebook &&
          Object.keys(context.selectedNotebook).length > 0;
        const hasNotebookTreeList =
          context.notebookTreeList &&
          Object.keys(context.notebookTreeList).length > 0;
        const hasNotesList = context.notesList !== null;
        const hasActiveFlexLayoutModel =
          context.activeFlexLayoutModel &&
          Object.keys(context.activeFlexLayoutModel).length > 0;

        // If the selected area of focus has notes, we need to ensure they are loaded.
        // Check both selected_stack and order_of_items to determine if there are notes
        const selectedStackHasNotes = context.selectedAreaOfFocus?.selected_stack?.length > 0;
        const orderOfItemsHasNotes = context.selectedAreaOfFocus?.order_of_items?.length > 0;
        const areaOfFocusHasNotes = selectedStackHasNotes || orderOfItemsHasNotes;

        // On mobile (or poor connections) fetchNotesFromCloudPaginated can fail, leaving
        // context.notes as {}. In that case hasNotes is still set to true by the error/offline
        // handler. Don't block priming forever — let applicationReady be entered so
        // NotesSync can perform a recovery sync.
        const notesLoadedButEmpty = context.hasNotes && (!context.notes || Object.keys(context.notes).length === 0);

        const notesInAreaOfFocusAreLoaded =
          areaOfFocusHasNotes && !notesLoadedButEmpty ?
            context.selectedNote &&
            Object.keys(context.selectedNote).length > 0 &&
            context.areaOfFocusOpenNoteObjects &&
            Object.keys(context.areaOfFocusOpenNoteObjects).length > 0 :
            true; // If no notes or notes failed to load, this condition is met.

        // If a note is selected, its corresponding notebook must also be selected.
        const selectedNoteHasNotebook = context.selectedNote ?
          context.selectedNotesNotebook &&
          Object.keys(context.selectedNotesNotebook).length > 0 :
          true; // If no note selected, this condition is met.

        const allConditionsMet =
          hasSelectedAreaOfFocus &&
          hasSelectedNotebook &&
          hasNotebookTreeList &&
          hasNotesList &&
          hasActiveFlexLayoutModel &&
          notesInAreaOfFocusAreLoaded &&
          selectedNoteHasNotebook;

        // Enhanced logging to identify which condition is failing
        if (!allConditionsMet) {
          logger.warn('hasPrimedData check failed. Conditions:', {
            hasSelectedAreaOfFocus,
            hasSelectedNotebook,
            hasNotebookTreeList,
            hasNotesList,
            hasActiveFlexLayoutModel,
            notesInAreaOfFocusAreLoaded,
            selectedNoteHasNotebook,
            contextDetails: {
              selectedAreaOfFocusKeys: context.selectedAreaOfFocus ? Object.keys(context.selectedAreaOfFocus).length : 0,
              selectedNotebookKeys: context.selectedNotebook ? Object.keys(context.selectedNotebook).length : 0,
              notebookTreeListKeys: context.notebookTreeList ? Object.keys(context.notebookTreeList).length : 0,
              notesListIsNull: context.notesList === null,
              activeFlexLayoutModelKeys: context.activeFlexLayoutModel ? Object.keys(context.activeFlexLayoutModel).length : 0,
              selectedNoteKeys: context.selectedNote ? Object.keys(context.selectedNote).length : 0,
              areaOfFocusOpenNoteObjectsKeys: context.areaOfFocusOpenNoteObjects ? Object.keys(context.areaOfFocusOpenNoteObjects).length : 0,
              selectedNotesNotebookKeys: context.selectedNotesNotebook ? Object.keys(context.selectedNotesNotebook).length : 0,
              areaOfFocusHasNotes,
              notesLoadedButEmpty,
              selectedStackHasNotes,
              orderOfItemsHasNotes,
            }
          });
        } else {
          logger.info('hasPrimedData: All conditions met, transitioning to applicationReady');
        }

        return allConditionsMet;
      },
      // validatePostNoteCreation: (context, event) => {
      //   logger.info({
      //     context,
      //     event,
      //   }, 'validatePostNoteCreation event');

      //   return true;
      // },
    },
    services: {},
  }
);
